<template>
  <div class="mb-5">
    <button @click="back"
      class="flex items-center font-semibold transition duration-300 hover:text-brand-indigo"
      type="button">
      <svg class='mr-1 icon icon-chevron-left'><use xlink:href='#icon-chevron-left'></use></svg>
      Back
    </button>
  </div>
</template>

<script setup>
import axios from 'axios';

const props = defineProps({
  page: Number,
  hash: String,
  status: String,
});

const emit = defineEmits(['updateCurrentPage']);

// Methods
const back = () => {
  switch(props.page) {
    case 1:
      window.location.href = "/";
      break;
    case 2:
      window.location.href = "/intake/style/" + props.hash;
      break;
    case 3:
      // For non-published forms, go back to IntakeWrapper; for published, go to previous tab
      if (props.status !== 'publish') {
        window.location.href = "/intake/" + props.hash;
      } else {
        emit('updateCurrentPage', props.page - 1);
      }
      break;
    case 4:
      // For non-published forms, go back to confirmation page; for published, go to previous tab
      if (props.status !== 'publish') {
        window.location.href = "/intake/style/" + props.hash + "?step=3";
      } else {
        emit('updateCurrentPage', props.page - 1);
      }
      break;
    case 5:
      emit('updateCurrentPage', props.page - 1);
      break;
    default:
      break;
  }
};

</script>
